var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00005 2.33334C1.73976 2.33334 1.50327 2.48483 1.39445 2.72128C1.28562 2.95773 1.32436 3.23589 1.49365 3.43361L6.13338 8.85235V12.8148C6.13338 13.0685 6.27738 13.3002 6.50486 13.4126L8.90486 14.5978C9.11151 14.6998 9.3562 14.6879 9.55194 14.5662C9.74768 14.4446 9.86672 14.2305 9.86672 14V8.85235L14.5064 3.43361C14.6757 3.23589 14.7145 2.95773 14.6057 2.72128C14.4968 2.48483 14.2603 2.33334 14 2.33334H2.00005Z",
    fill: "white",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.c506ef304d11ba2e6d2486a73ec80470.svg";
export { ForwardRef as ReactComponent };